import * as actions from './actionTypes'

export const cookiedEnabledAction = (flag) => ({
  type: actions.COOKIES_ENABLED,
  payload: {
    description: flag,
  },
})

export const screenLoadingAction = () => ({
  type: actions.SCREEN_LOADING,
})

export const masterNumberAction = (value) => ({
  type: actions.MASTER_NUMBER,
  payload: {
    description: value.toUpperCase(),
  },
})

export const emailAddressAction = (value) => ({
  type: actions.EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const confirmEmailAddressAction = (value) => ({
  type: actions.CONFIRM_EMAIL_ADDRESS,
  payload: {
    description: value,
  },
})

export const phoneNumberAction = (value) => ({
  type: actions.PHONE_NUMBER,
  payload: {
    description: value,
  },
})

export const clearAllAction = () => ({
  type: actions.CLEAR_ALL,
})
